import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate";

export default createStore({
    state: {
        cart: {
            cartKey : null,
            upjangCode: null,
            data: null,
        }
    },
    mutations: {
        updateCartInfo(state, data){
            state.cart = data
            console.log("mutations updateCartInfo", state.cart)
        },
        removeCartInfo(state) {
            state.cart = {
                cartKey : null,
                upjangCode: null,
                data: null,
            }
        },
    },
    getters: {

    },
    actions: {
        setCartInfo: ({commit}, data) => {
            console.log('commit setCartInfo', data)
            commit('updateCartInfo', data);
        },
        removeCartInfo: ({commit}) => {
            commit('removeCartInfo');
        }
    },
    modules: {},
    plugins: [
        createPersistedState()
    ]
})